export default __webpack_public_path__ + "static/media/resume.9e9e0dfd.pdf";